import Mapper from './Mapper';
import { PriceAnyResponseDTO } from 'typings/dto/price';

export default class PricePlatformOperatorMapper extends Mapper<
  Price.PlatformOperator,
  PriceAnyResponseDTO.PlatformOperator
> {
  constructor() {
    super(
      {
        currency: 'currency',
        owner: 'owner',
        region: 'region',
        serviceItem: 'service',
        attributes: 'attributes',
        catalogPrice: 'clientValue',
        clientPrice: 'clientPrice',
        type: 'type',
        promotion: 'promotion',
        productPrice: 'productPrice',
      }
    );
  }

  public responseDTOToModel(dto: PriceAnyResponseDTO.PlatformOperator): Price.PlatformOperator {
    return {
      ...(this.getOuterMappers().priceAny.responseDTOToModel(dto) as Price.PlatformOperator),
    };
  }

  public responseDTOToModelIdAndNamesOnly = (dto: PriceAnyResponseDTO.PlatformOperator): Price.PlatformOperator => {
    return this.responseDTOToModel(dto);
  };
}
